import React, { useEffect } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Images, Wand2, LogOut, Home, Palette, Settings, BookOpen, FileText, Image as ImageIcon, Package, Gamepad2, Layers } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { isAuthenticated, adminLogout } from '../../services/api';
import { toast } from 'sonner';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    adminLogout();
    toast.success('Logout effettuato');
    navigate('/admin/login');
  };

  const navItems = [
    { path: '/admin', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/admin/illustrations', label: 'Illustrazioni', icon: Images },
    { path: '/admin/posters', label: 'Poster', icon: ImageIcon },
    { path: '/admin/bundles', label: 'Bundle', icon: Package },
    { path: '/admin/themes', label: 'Temi', icon: Palette },
    { path: '/admin/books', label: 'Libri', icon: BookOpen },
    { path: '/admin/games', label: 'Giochi', icon: Gamepad2 },
    { path: '/admin/level-backgrounds', label: 'Sfondi Livelli', icon: Layers },
    { path: '/admin/generator', label: 'Generatore AI', icon: Wand2 },
    { path: '/admin/brand-kit', label: 'Brand Kit', icon: FileText },
    { path: '/admin/settings', label: 'Impostazioni', icon: Settings },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-gray-200 fixed h-full">
        <div className="p-6">
          <Link to="/admin" className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-200 to-blue-200 flex items-center justify-center">
              <span className="text-xl">🦄</span>
            </div>
            <div>
              <span className="font-bold text-gray-800">Poppiconni</span>
              <p className="text-xs text-gray-500">Admin Panel</p>
            </div>
          </Link>
        </div>
        
        <nav className="px-4 space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                isActive(item.path)
                  ? 'bg-pink-100 text-pink-600'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <item.icon className="w-5 h-5" />
              <span className="font-medium">{item.label}</span>
            </Link>
          ))}
        </nav>
        
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
          <Link to="/">
            <Button variant="ghost" className="w-full justify-start mb-2">
              <Home className="w-4 h-4 mr-2" />
              Vai al Sito
            </Button>
          </Link>
          <Button variant="ghost" className="w-full justify-start text-red-500 hover:text-red-600 hover:bg-red-50" onClick={handleLogout}>
            <LogOut className="w-4 h-4 mr-2" />
            Esci
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
